import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  connect() {
    // Listen for events to open the modal from other controllers if needed
  }

  disconnect() {
    this.toggleScrollLock(false, true)
  }

  open(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    const workoutId = event.currentTarget.dataset.workoutId
    if (!workoutId) return

    this.modalTarget.classList.remove("hidden")
    this.toggleScrollLock(true)
    
    // Fetch workout content via Turbo
    this.contentTarget.innerHTML = `
      <div class="flex flex-col items-center justify-center py-20">
        <div class="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        <p class="mt-4 text-xs font-black text-gray-400 uppercase tracking-widest">Loading Workout Plan...</p>
      </div>
    `
    
    fetch(`/workouts/${workoutId}?modal=true`, {
      headers: { "Accept": "text/html" }
    })
    .then(response => response.text())
    .then(html => {
      this.contentTarget.innerHTML = html
    })
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    this.toggleScrollLock(false)
  }

  toggleScrollLock(lock, force = false) {
    const body = document.body
    const html = document.documentElement
    let openModals = parseInt(body.dataset.openModals || "0")

    if (lock) {
      openModals++
      body.dataset.openModals = openModals
      
      if (openModals === 1) {
        this.scrollPos = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.scrollPos}px`
        body.style.width = '100%'
        body.classList.add('overflow-hidden')
        html.classList.add('overflow-hidden')
      }
    } else {
      openModals = force ? 0 : Math.max(0, openModals - 1)
      body.dataset.openModals = openModals
      
      if (openModals === 0) {
        const scrollY = body.style.top
        body.style.position = ''
        body.style.top = ''
        body.style.width = ''
        body.classList.remove('overflow-hidden')
        html.classList.remove('overflow-hidden')
        if (!force) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
      }
    }
  }
}
